var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "media-library-page"
  }, [_c('b-card', {
    staticClass: "media-library-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "media-library-header"
  }, [_c('div', {
    staticClass: "media-library-hero"
  }, [_c('div', {
    staticClass: "media-library-hero__icon"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "ImageIcon",
      "size": "20"
    }
  })], 1), _c('div', [_c('h2', {
    staticClass: "mb-25"
  }, [_vm._v("Media Library")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Browse, search, upload, and manage reusable media across products, sliders, categories, and library uploads. ")])])]), _c('div', {
    staticClass: "media-library-actions"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--primary",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.fileInput.click();
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "UploadCloudIcon",
      "size": "16"
    }
  }), _c('span', [_vm._v("Upload Media")])], 1), _c('input', {
    ref: "fileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  }), _c('b-button', {
    staticClass: "media-btn media-btn--ghost",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.fetchLibrary
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "RefreshCwIcon",
      "size": "16"
    }
  }), _c('span', [_vm._v("Refresh")])], 1)], 1)]), _c('div', {
    staticClass: "media-toolbar-card"
  }, [_c('div', {
    staticClass: "media-library-toolbar"
  }, [_c('div', {
    staticClass: "media-library-toolbar__left media-library-toolbar__left--inline"
  }, [_c('b-input-group', {
    staticClass: "media-search-box media-control",
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('b-input-group-text', {
          staticClass: "media-control__prepend"
        }, [_c('feather-icon', {
          attrs: {
            "icon": "SearchIcon",
            "size": "15"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Live search by image/file name..."
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "search"
    }
  })], 1), _c('b-form-select', {
    staticClass: "media-filter-select media-control",
    attrs: {
      "options": _vm.sourceOptions
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.source,
      callback: function ($$v) {
        _vm.source = $$v;
      },
      expression: "source"
    }
  }), _c('b-form-select', {
    staticClass: "media-filter-select media-control",
    attrs: {
      "options": _vm.typeOptions
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.type,
      callback: function ($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }), _c('b-form-select', {
    staticClass: "media-filter-select media-filter-select--wide media-control",
    attrs: {
      "options": _vm.collectionOptions
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.collection,
      callback: function ($$v) {
        _vm.collection = $$v;
      },
      expression: "collection"
    }
  }), _c('b-form-select', {
    staticClass: "media-filter-select media-control",
    attrs: {
      "options": _vm.perPageOptions
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.perPage,
      callback: function ($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1), _c('div', {
    staticClass: "media-library-toolbar__right media-library-toolbar__right--inline"
  }, [_c('div', {
    staticClass: "media-summary-pill"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "LayersIcon",
      "size": "14"
    }
  }), _vm.pagination.total ? _c('span', [_vm._v(" " + _vm._s(_vm.pagination.from || 0) + "-" + _vm._s(_vm.pagination.to || 0) + " of " + _vm._s(_vm.pagination.total) + " ")]) : _c('span', [_vm._v("0 items")])], 1)])]), _c('div', {
    staticClass: "media-stat-chips"
  }, [_c('span', {
    staticClass: "media-chip media-chip--primary"
  }, [_vm._v("Source: " + _vm._s(_vm.sourceLabel))]), _c('span', {
    staticClass: "media-chip media-chip--secondary"
  }, [_vm._v("Type: " + _vm._s(_vm.typeLabel))]), _c('span', {
    staticClass: "media-chip media-chip--info"
  }, [_vm._v("Collection: " + _vm._s(_vm.collectionLabel))]), _c('span', {
    staticClass: "media-chip media-chip--success"
  }, [_vm._v("Per page: " + _vm._s(_vm.perPage))]), _c('span', {
    staticClass: "media-chip media-chip--warning"
  }, [_vm._v("Selected: " + _vm._s(_vm.selectedIds.length))])])]), _vm.selectedIds.length ? _c('div', {
    staticClass: "media-bulk-bar"
  }, [_c('div', {
    staticClass: "media-bulk-bar__left"
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": _vm.allVisibleSelected,
      "switch": ""
    },
    on: {
      "change": _vm.toggleSelectAllVisible
    }
  }, [_vm._v(" Select all visible ")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.selectedIds.length) + " item(s) selected")])], 1), _c('div', {
    staticClass: "media-bulk-bar__right"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--ghost",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v(" Clear Selection ")]), _c('b-button', {
    staticClass: "media-btn media-btn--danger",
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "disabled": !_vm.canBulkDelete || _vm.isBulkDeleting
    },
    on: {
      "click": _vm.bulkDeleteSelected
    }
  }, [_vm.isBulkDeleting ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Bulk Delete ")], 1)], 1)]) : _vm._e(), _vm.uploadQueue.length ? _c('div', {
    staticClass: "media-upload-panel"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "mb-50"
  }, [_vm._v("Ready to Upload")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.uploadQueue.length) + " file(s) selected")])]), _c('div', {
    staticClass: "d-flex align-items-center mt-1 mt-md-0"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--primary",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isUploading
    },
    on: {
      "click": _vm.uploadSelectedFiles
    }
  }, [_vm.isUploading ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isUploading ? 'Uploading...' : 'Upload Now') + " ")], 1), _c('b-button', {
    staticClass: "media-btn media-btn--ghost ml-1",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "disabled": _vm.isUploading
    },
    on: {
      "click": _vm.clearUploadQueue
    }
  }, [_vm._v(" Clear ")])], 1)]), _c('div', {
    staticClass: "upload-queue-list mt-1"
  }, _vm._l(_vm.uploadQueue, function (file, index) {
    return _c('div', {
      key: ((file.name) + "-" + index),
      staticClass: "upload-queue-list__item"
    }, [_c('div', {
      staticClass: "d-flex align-items-center min-width-0"
    }, [_c('div', {
      staticClass: "upload-queue-list__icon"
    }, [_c('feather-icon', {
      attrs: {
        "icon": "FileIcon",
        "size": "14"
      }
    })], 1), _c('span', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(file.name))])]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatFileSize(file.size)))])]);
  }), 0)]) : _vm._e(), _vm.activeItem ? _c('div', {
    staticClass: "media-mobile-selection-bar"
  }, [_c('div', {
    staticClass: "media-mobile-selection-bar__left"
  }, [_c('div', {
    staticClass: "media-mobile-selection-bar__thumb"
  }, [_vm.isImage(_vm.activeItem) ? _c('img', {
    attrs: {
      "src": _vm.activeItem.preview_url || _vm.activeItem.original_url,
      "alt": _vm.activeItem.file_name || _vm.activeItem.name
    },
    on: {
      "error": _vm.handleImageError
    }
  }) : _c('div', {
    staticClass: "media-mobile-selection-bar__thumb-fallback"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "FileTextIcon",
      "size": "14"
    }
  })], 1)]), _c('div', {
    staticClass: "media-mobile-selection-bar__meta"
  }, [_c('div', {
    staticClass: "media-mobile-selection-bar__name"
  }, [_vm._v(" " + _vm._s(_vm.activeItem.file_name || _vm.activeItem.name || 'Selected item') + " ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.activeItem.collection_name || 'media'))])])]), _c('b-button', {
    staticClass: "media-btn media-btn--primary media-mobile-selection-bar__button",
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        _vm.mobileDetailsOpen = true;
      }
    }
  }, [_vm._v(" Details ")])], 1) : _vm._e(), _vm.mobileDetailsOpen ? _c('div', {
    staticClass: "media-mobile-backdrop",
    on: {
      "click": function ($event) {
        _vm.mobileDetailsOpen = false;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "media-mobile-drawer",
    class: {
      'is-open': _vm.mobileDetailsOpen
    }
  }, [_c('div', {
    staticClass: "media-mobile-drawer__handle"
  }), _c('div', {
    staticClass: "media-mobile-drawer__header"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Attachment Details")]), _c('b-button', {
    staticClass: "btn-icon",
    attrs: {
      "variant": "flat-secondary"
    },
    on: {
      "click": function ($event) {
        _vm.mobileDetailsOpen = false;
      }
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "XIcon",
      "size": "18"
    }
  })], 1)], 1), _vm.activeItem ? _c('div', {
    staticClass: "media-mobile-drawer__body"
  }, [_c('div', {
    staticClass: "media-sidebar-preview mb-1"
  }, [_vm.isImage(_vm.activeItem) ? _c('img', {
    attrs: {
      "src": _vm.activeItem.original_url || _vm.activeItem.preview_url,
      "alt": _vm.activeItem.file_name || _vm.activeItem.name
    },
    on: {
      "error": _vm.handleImageError
    }
  }) : _c('div', {
    staticClass: "media-sidebar-preview__fallback"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "FileTextIcon",
      "size": "30"
    }
  })], 1)]), _c('ul', {
    staticClass: "list-unstyled media-sidebar-meta mb-1"
  }, [_c('li', [_c('strong', [_vm._v("File:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.file_name || _vm.activeItem.name || '--'))])]), _c('li', [_c('strong', [_vm._v("Type:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.mime_type || '--'))])]), _c('li', [_c('strong', [_vm._v("Source:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.model_type || '--'))])]), _c('li', [_c('strong', [_vm._v("Collection:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.collection_name || '--'))])]), _c('li', [_c('strong', [_vm._v("Size:")]), _c('span', [_vm._v(_vm._s(_vm.formatFileSize(_vm.activeItem.size || 0)))])]), _c('li', [_c('strong', [_vm._v("ID:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.id))])])]), _c('b-form-group', {
    attrs: {
      "label": "Name",
      "label-for": "media-name-mobile"
    }
  }, [_c('b-form-input', {
    staticClass: "media-control",
    attrs: {
      "id": "media-name-mobile",
      "placeholder": "Media name"
    },
    model: {
      value: _vm.editForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "name", $$v);
      },
      expression: "editForm.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Alt text",
      "label-for": "media-alt-mobile"
    }
  }, [_c('b-form-textarea', {
    staticClass: "media-control",
    attrs: {
      "id": "media-alt-mobile",
      "rows": "2",
      "placeholder": "Alt text"
    },
    model: {
      value: _vm.editForm.alt,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "alt", $$v);
      },
      expression: "editForm.alt"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Caption",
      "label-for": "media-caption-mobile"
    }
  }, [_c('b-form-textarea', {
    staticClass: "media-control",
    attrs: {
      "id": "media-caption-mobile",
      "rows": "2",
      "placeholder": "Caption"
    },
    model: {
      value: _vm.editForm.caption,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "caption", $$v);
      },
      expression: "editForm.caption"
    }
  })], 1), _c('div', {
    staticClass: "media-sidebar-actions"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--primary",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.saveMetadata
    }
  }, [_vm.isSaving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isSaving ? 'Saving...' : 'Save Details') + " ")], 1), _c('b-button', {
    staticClass: "media-btn media-btn--ghost",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.copyUrl(_vm.activeItem);
      }
    }
  }, [_vm._v(" Copy URL ")]), _c('b-button', {
    staticClass: "media-btn media-btn--ghost",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.openOriginal(_vm.activeItem);
      }
    }
  }, [_vm._v(" Open ")])], 1), _c('div', {
    staticClass: "mt-2"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--danger",
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "disabled": !_vm.canDeleteActive || _vm.isDeleting
    },
    on: {
      "click": _vm.removeMedia
    }
  }, [_vm.isDeleting ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Delete ")], 1), !_vm.canDeleteActive ? _c('small', {
    staticClass: "d-block text-muted mt-50"
  }, [_vm._v(" Only library uploads can be deleted here. ")]) : _vm._e()], 1)], 1) : _vm._e()]), _c('div', {
    staticClass: "media-library-content"
  }, [_c('div', {
    staticClass: "media-library-main"
  }, [_c('div', {
    staticClass: "media-dropzone mb-2",
    class: {
      'is-dragging': _vm.isDragging
    },
    on: {
      "dragenter": function ($event) {
        $event.preventDefault();
        _vm.isDragging = true;
      },
      "dragover": function ($event) {
        $event.preventDefault();
        _vm.isDragging = true;
      },
      "dragleave": function ($event) {
        $event.preventDefault();
        _vm.isDragging = false;
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.handleDrop($event);
      }
    }
  }, [_c('div', {
    staticClass: "media-dropzone__inner"
  }, [_c('div', {
    staticClass: "media-dropzone__icon"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "ImageIcon",
      "size": "24"
    }
  })], 1), _c('div', {
    staticClass: "font-weight-bolder"
  }, [_vm._v("Drop files here to upload")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("or use the Upload Media button above")])])]), _vm.isLoading ? _c('div', {
    staticClass: "media-state media-state--loading"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('p', {
    staticClass: "text-muted mt-1 mb-0"
  }, [_vm._v("Loading media...")])], 1) : _vm.mediaItems.length ? _c('div', {
    staticClass: "media-grid"
  }, _vm._l(_vm.mediaItems, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "media-grid__item",
      class: {
        'is-active': _vm.activeItem && _vm.activeItem.id === item.id,
        'is-selected': _vm.isSelected(item.id)
      },
      on: {
        "click": function ($event) {
          return _vm.selectItem(item);
        }
      }
    }, [_c('div', {
      staticClass: "media-grid__thumb"
    }, [_vm.isImage(item) ? _c('img', {
      attrs: {
        "src": item.preview_url || item.original_url,
        "alt": item.file_name || item.name,
        "loading": "lazy"
      },
      on: {
        "error": _vm.handleImageError
      }
    }) : _c('div', {
      staticClass: "media-grid__fallback"
    }, [_c('feather-icon', {
      attrs: {
        "icon": "FileTextIcon",
        "size": "26"
      }
    })], 1), _c('span', {
      staticClass: "media-grid__badge"
    }, [_vm._v(" " + _vm._s(item.collection_name || 'media') + " ")]), _c('label', {
      staticClass: "media-grid__checkbox",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isSelected(item.id)
      },
      on: {
        "change": function ($event) {
          return _vm.toggleSelection(item);
        }
      }
    }), _c('span')])]), _c('div', {
      staticClass: "media-grid__meta"
    }, [_c('div', {
      staticClass: "media-grid__name"
    }, [_vm._v(" " + _vm._s(item.file_name || item.name || 'Untitled') + " ")]), _c('div', {
      staticClass: "media-grid__sub"
    }, [_vm._v(" " + _vm._s(_vm.humanMime(item.mime_type)) + " ")])])]);
  }), 0) : _c('div', {
    staticClass: "media-state media-state--empty"
  }, [_c('div', {
    staticClass: "media-empty-icon"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "ImageIcon",
      "size": "34"
    }
  })], 1), _c('h5', {
    staticClass: "mb-50 mt-1"
  }, [_vm._v("No media found")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Try changing filters or upload new media. ")])]), _vm.pagination.total > _vm.pagination.per_page ? _c('div', {
    staticClass: "media-pagination"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.pagination.total,
      "per-page": _vm.pagination.per_page,
      "first-number": "",
      "last-number": "",
      "align": "center"
    },
    on: {
      "input": _vm.onPageChange
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "media-library-sidebar"
  }, [_c('b-card', {
    staticClass: "media-sidebar-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "media-sidebar-card__header"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Attachment Details")])]), _c('div', {
    staticClass: "media-sidebar-card__body"
  }, [_vm.activeItem ? _c('div', [_c('div', {
    staticClass: "media-sidebar-preview mb-1"
  }, [_vm.isImage(_vm.activeItem) ? _c('img', {
    attrs: {
      "src": _vm.activeItem.original_url || _vm.activeItem.preview_url,
      "alt": _vm.activeItem.file_name || _vm.activeItem.name
    },
    on: {
      "error": _vm.handleImageError
    }
  }) : _c('div', {
    staticClass: "media-sidebar-preview__fallback"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "FileTextIcon",
      "size": "30"
    }
  })], 1)]), _c('ul', {
    staticClass: "list-unstyled media-sidebar-meta mb-1"
  }, [_c('li', [_c('strong', [_vm._v("File:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.file_name || _vm.activeItem.name || '--'))])]), _c('li', [_c('strong', [_vm._v("Type:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.mime_type || '--'))])]), _c('li', [_c('strong', [_vm._v("Source:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.model_type || '--'))])]), _c('li', [_c('strong', [_vm._v("Collection:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.collection_name || '--'))])]), _c('li', [_c('strong', [_vm._v("Size:")]), _c('span', [_vm._v(_vm._s(_vm.formatFileSize(_vm.activeItem.size || 0)))])]), _c('li', [_c('strong', [_vm._v("ID:")]), _c('span', [_vm._v(_vm._s(_vm.activeItem.id))])])]), _c('b-form-group', {
    attrs: {
      "label": "Name",
      "label-for": "media-name"
    }
  }, [_c('b-form-input', {
    staticClass: "media-control",
    attrs: {
      "id": "media-name",
      "placeholder": "Media name"
    },
    model: {
      value: _vm.editForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "name", $$v);
      },
      expression: "editForm.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Alt text",
      "label-for": "media-alt"
    }
  }, [_c('b-form-textarea', {
    staticClass: "media-control",
    attrs: {
      "id": "media-alt",
      "rows": "2",
      "placeholder": "Alt text"
    },
    model: {
      value: _vm.editForm.alt,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "alt", $$v);
      },
      expression: "editForm.alt"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Caption",
      "label-for": "media-caption"
    }
  }, [_c('b-form-textarea', {
    staticClass: "media-control",
    attrs: {
      "id": "media-caption",
      "rows": "2",
      "placeholder": "Caption"
    },
    model: {
      value: _vm.editForm.caption,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "caption", $$v);
      },
      expression: "editForm.caption"
    }
  })], 1), _c('div', {
    staticClass: "media-sidebar-actions"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--primary",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.saveMetadata
    }
  }, [_vm.isSaving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isSaving ? 'Saving...' : 'Save Details') + " ")], 1), _c('b-button', {
    staticClass: "media-btn media-btn--ghost",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.copyUrl(_vm.activeItem);
      }
    }
  }, [_vm._v(" Copy URL ")]), _c('b-button', {
    staticClass: "media-btn media-btn--ghost",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.openOriginal(_vm.activeItem);
      }
    }
  }, [_vm._v(" Open ")])], 1), _c('div', {
    staticClass: "mt-2"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--danger",
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "disabled": !_vm.canDeleteActive || _vm.isDeleting
    },
    on: {
      "click": _vm.removeMedia
    }
  }, [_vm.isDeleting ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Delete ")], 1), !_vm.canDeleteActive ? _c('small', {
    staticClass: "d-block text-muted mt-50"
  }, [_vm._v(" Only library uploads can be deleted here. ")]) : _vm._e()], 1)], 1) : _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Select any media item to preview and edit details. ")])])])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }